import { render, staticRenderFns } from "./PrintShippingLabels.vue?vue&type=template&id=1cbcb4a2&"
import script from "./PrintShippingLabels.vue?vue&type=script&lang=js&"
export * from "./PrintShippingLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports